var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCareer = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M13.424 10.013a3.427 3.427 0 0 0 1.217-6.632M7.658 9.333a3.715 3.715 0 1 0 0-7.43 3.715 3.715 0 0 0 0 7.43Z",
  stroke: "#3A434A",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.348 14.552c1.817 1.21.59 3.545-1.593 3.545H3.556c-2.183 0-3.41-2.335-1.593-3.545a10.234 10.234 0 0 1 5.693-1.718c2.105 0 4.062.633 5.692 1.718Z",
  stroke: "#3A434A",
  strokeWidth: 1.5
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M11.439 18.097h5.197c2.014 0 3.146-2.154 1.47-3.27a9.468 9.468 0 0 0-1.47-.802",
  stroke: "#3A434A",
  strokeWidth: 1.5,
  strokeLinecap: "round"
})));
export default SvgCareer;